import { fetch } from '../utils/fetch'

/*
    API:    GET
    NAME:   获取订单列表
*/
export function getOrderList(data) {
  return fetch({
    url: `order/queryList`,
    method: 'get',
    params: data
  })
}

/*
    API:    GET
    NAME:   获取订单支付结果
*/
export function getOrderInfo(orderNo) {
  return fetch({
    url: `order/queryPayStatus/${orderNo}`,
    method: 'get'
  })
}
